import { InjectionToken, Type } from "@angular/core";

// Ska eventuellt ändras till en definitions fil istället om andra förvaltningar är intresserade

export const DASHBOARD_CONFIG = new InjectionToken<DashboardConfig>("DashboardConfig");

export interface DashboardConfig {
  widgets?: { [key: string]: Type<any> };
  columns?: number;
  rows?: number;
  cellGap?: number;
  data?: WidgetData[];
}

export type WidgetData = {
  id: string;
  dimensions: CellDimension;
  component?: string;
  properties?: { [key: string]: any };
};

export type CellDimension = {
  row: number;
  column: number;
  width: number;
  height: number;
};
